import { render, staticRenderFns } from "./MessagePlainTextBody.vue?vue&type=template&id=375b1446&scoped=true&"
import script from "./MessagePlainTextBody.vue?vue&type=script&lang=js&"
export * from "./MessagePlainTextBody.vue?vue&type=script&lang=js&"
import style0 from "./MessagePlainTextBody.vue?vue&type=style&index=0&id=375b1446&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375b1446",
  null
  
)

export default component.exports